/*
Sohel 11/14/2022 2699767208 implemented Copy Functionality
Sohel 12/01/2022 2699767208 Added Validation
sai krisha 30/12/2022 2699767208 add code description values
Raghu 02/28/2023 2699767208 added new class for text fields
sohel 03/06/2023 2699767208 Added validation message for existing value
Akhila 06/07/2023 2699767208 added breadcrum code and description
sohel 12/11/2023 2699767208  Added validation for TriggerCode and Trigger Description in Triggers Maintenance
*/
import React, {useContext, useEffect} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {postCopyReport} from '../../../../redux/reducers/EventTactics/EventTactics';
import PageLoader from './../../../../components/PageLoader/index';
import {fetchAllTriggerCode} from '../../../../redux/reducers/EventTactics/EventTactics';
import BreadCrums from '../../../../util/BreadCrum';
const CopyReport = ({oldTriggerCode, codeAndDescription}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {iscopyLoading, allTriggerCode} = useSelector(({addEventTactic}) => addEventTactic);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    triggercode: '',
    title: '',
  };

  const checkTriggerCodeExist = (value) => {
    if (allTriggerCode && allTriggerCode?.length > 0 && value) {
      const ar = [];
      allTriggerCode.filter((i) => {
        if (
          i?.code?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkTriggerAlreadyCodeExist = (value) => {
    if (allTriggerCode && allTriggerCode?.length > 0 && value) {
      const ar = [];
      allTriggerCode.filter((i) => {
        if (
          i?.code?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const schema = Yup.object().shape({
    triggercode: Yup.string()
      .required('Trigger Name is required')
      .test('code', 'Trigger Name already exist', (value) => !checkTriggerCodeExist(value))
      .test(
        'code',
        'Trigger Name has already been used in the past',
        (value) => !checkTriggerAlreadyCodeExist(value),
      ),
    title: Yup.string()
      .required('Trigger Description is required'),
  });

  const handleSubmit = (values) => {
    if (values) {
      const data = {
        triggerId:0,
        triggerCode: values?.triggerCode ? values?.triggerCode : '',
        oldTriggerId:codeAndDescription?.id ? codeAndDescription?.id : '',
        oldTriggerCode: oldTriggerCode,
        triggerDescription: values?.title ? values?.title : '',
      };
      dispatch(postCopyReport(data));
    }
  };

  useEffect(() => {
    dispatch(fetchAllTriggerCode());
  }, []);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Trigger Name'}
                    code={codeAndDescription?.code}
                    description={'Description'}
                    descriptionValue={codeAndDescription?.description}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Trigger Name"
                              margin="dense"
                              name="triggercode"
                              variant="outlined"
                              value={values?.triggercode}
                              label="Trigger Name"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              inputProps={{maxLength:25}}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('triggerCode', e.target.value);
                              }}
                              touched={touched.triggercode}
                              error={Boolean(errors.triggercode && touched.triggercode)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.triggercode && errors.triggercode}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Trigger Description"
                              margin="dense"
                              name="title"
                              value={values.title}
                              variant="outlined"
                              label="Trigger Description"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('title', e.target.value);
                              }}
                              touched={touched.title}
                              required
                              inputProps={{maxLength:100}}
                              error={Boolean(errors.title && touched.title)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.title && errors.title}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {iscopyLoading && <PageLoader />}
    </>
  );
};

export default CopyReport;
